<div class="tile fx-column" [class.sepia]="showHistoricNotice && (stations.isHistoric$ | async)">
    <!-- HEADER -->
    <div class="tile-header fx-align-space-between-center fx-row">
        <h2>{{ title }} <mat-icon *ngIf="showTitleWarning" class="warn" svgIcon="m-alert-circle"></mat-icon></h2>
        <ng-content select="[tile-header]"></ng-content>
        <button
            *ngIf="!hideOpenDialogBtn"
            mat-icon-button
            (click)="openDialogClick()"
            (keydown.enter)="openDialogClick()"
        >
            <mat-icon svgIcon="c-maximize"></mat-icon>
        </button>
        <div class="loading-bar">
            <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
        </div>
    </div>
    <!-- CONTENT -->
    <div class="fx-flex tile-content">
        <ng-content select="[tile-content]"></ng-content>
    </div>
    <!-- FOOTER -->
    <div class="tile-footer">
        <ng-content select="[tile-footer]"></ng-content>
    </div>

    <div
        class="historic fx-align-start-center fx-layout-gap-4 fx-row"
        *ngIf="showHistoricNotice && (stations.isHistoric$ | async)"
    >
        <mat-icon svgIcon="history" *ngIf="!(stations.historicLoading$ | async)"></mat-icon>
        <mat-spinner [diameter]="24" mode="indeterminate" *ngIf="stations.historicLoading$ | async"></mat-spinner>
        <span>{{
            stations.seekTime$
                | async
                | adjustUtcDate: { format: 'DD.MM.yyyy HH:mm', time: (currentTime$ | async), showUtcTimeLabel: true }
        }}</span>
    </div>
</div>
